export default "__VITE_ASSET__dff77ffd__"